import { useBreakpoint } from "@amzn/aws-euc-ui";
import { useLayoutEffect } from "react";
import classNames from "classnames";
import { ClassName } from "../../../constants/styles";

// TODO [LOWA-30534] From: https://tiny.amazon.com/1ih36bpnl
export const useSetDeviceTypeClass = () => {
    const { isDesktopOrLaptop } = useBreakpoint();

    // Check device type
    useLayoutEffect(() => {
        document.documentElement.className = classNames(
            document.documentElement.className,
            {
                [ClassName.DESKTOP_LAPTOP_DEVICE_TYPE]: isDesktopOrLaptop,
                [ClassName.MOBILE_TABLET_DEVICE_TYPE]: !isDesktopOrLaptop,
            }
        );
    }, [isDesktopOrLaptop]);
};
